import WestHamLogo from '@images/sponsors/west-ham-icon.svg?react'
import { tr } from 'mmfintech-commons'

export const sponsors = () => [
  {
    title: tr('FRONTEND.SPONSORS.WEST_HAM_TITLE', 'West Ham United F.C.'),
    Image: WestHamLogo
  }
]
